import { render } from "./AnswerPageFive.vue?vue&type=template&id=1c21668c&scoped=true"
import script from "./AnswerPageFive.vue?vue&type=script&lang=js"
export * from "./AnswerPageFive.vue?vue&type=script&lang=js"

import "./AnswerPageFive.vue?vue&type=style&index=0&id=1c21668c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c21668c"]])

export default __exports__